import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";

const SR = typeof window !== "undefined" ? window.SpeechRecognition || window.webkitSpeechRecognition : null;
export const wakeSupported = () => !!SR;
const WAKE = /\b(hey|hi|ok|okay)[,\s]+velocity\b|\bvelocity[,\s]+(wake up|listen|start)\b/i;

// Always-on wake word listener using the browser's speech recognizer. No audio leaves the device until the wake word is heard.
export function useWakeWord({ enabled, paused, onWake }) {
  const [state, setState] = useState("off");
  const recRef = useRef(null);
  const onWakeRef = useRef(onWake);
  useEffect(() => { onWakeRef.current = onWake; }, [onWake]);
  useEffect(() => {
    if (!enabled || paused || !SR) { recRef.current?.stop?.(); recRef.current = null; setState(enabled && !SR ? "unsupported" : "off"); return; }
    let alive = true;
    const rec = new SR(); rec.continuous = true; rec.interimResults = true; rec.lang = "en-US";
    rec.onresult = (e) => { for (let i = e.resultIndex; i < e.results.length; i++) { const t = e.results[i][0].transcript; if (WAKE.test(t)) { setState("woke"); rec.stop(); onWakeRef.current?.(); return; } } };
    rec.onstart = () => alive && setState("listening");
    rec.onerror = (e) => { if (e.error === "not-allowed" || e.error === "service-not-allowed") { alive = false; setState("blocked"); toast.error("Microphone blocked — allow it to use \"Hey Velocity\""); } };
    rec.onend = () => { if (alive && !paused) setTimeout(() => { try { rec.start(); } catch { /* already started */ } }, 400); };
    try { rec.start(); } catch { setState("blocked"); }
    recRef.current = rec;
    return () => { alive = false; try { rec.onend = null; rec.stop(); } catch { /* noop */ } recRef.current = null; };
  }, [enabled, paused]);
  return state;
}
